import * as RadixDropdownMenu from "@radix-ui/react-dropdown-menu";
import { styled } from "src/styles/theme";

const Content = styled(RadixDropdownMenu.Content, {
  minWidth: "16rem",
  padding: "$2 0",
  boxShadow: "$4",
  borderRadius: "$2",
  backgroundColor: "$background",
});

const Separator = styled(RadixDropdownMenu.Separator, {
  height: 1,
  margin: "$2 0",
  backgroundColor: "$neutral4",
});

const Label = styled(RadixDropdownMenu.Label, {
  display: "block",
  margin: "$3 $4 $1",
  color: "$neutralText",
  fontSize: "$sm",
  fontWeight: "$light",
  opacity: 0.8,
});

const Item = styled(RadixDropdownMenu.Item, {
  display: "flex",
  alignItems: "center",
  padding: "$3 $6",
  color: "$neutralText",
  fontSize: "$sm",
  cursor: "pointer",
  textDecoration: "none",
  transition: "all $duration1 ease",

  "&:hover, &:focus": {
    backgroundColor: "$neutralBg",
  },

  "&:focus": {
    outline: "none",
  },

  svg: {
    width: "1rem",
    height: "1rem",
  },

  "svg:first-child": {
    marginRight: "$3",
  },

  "svg:last-child": {
    marginLeft: "auto",
  },
});

export const DropdownMenu = {
  ...RadixDropdownMenu,
  Content,
  Label,
  Item,
  Separator,
};
